export const fallbackCopyTextToClipboard = (text: string): boolean => {
    if (typeof document === 'undefined') return false

    try {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'fixed'
        textarea.style.top = '0'
        textarea.style.left = '0'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        const ok = document.execCommand('copy')
        document.body.removeChild(textarea)
        return ok
    } catch (error) {
        console.warn('Fallback clipboard copy failed.', error)
        return false
    }
}

export const copyTextToClipboard = async (text: string): Promise<boolean> => {
    if (!text) return false

    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text)
            return true
        } catch (error) {
            console.warn('Clipboard API writeText failed, falling back.', error)
        }
    }

    return fallbackCopyTextToClipboard(text)
}
